import{__rest as e}from"../_virtual/_tslib.js";import{jsx as r}from"react/jsx-runtime";import{calculateRem as t,withVDSManager as o}from"@vds-core/utilities";import n,{css as a}from"styled-components";import{ColorTokens as i}from"@vds-tokens/color";import{LayoutTokens as d}from"@vds-tokens/layout";const l=d.space["3X"].value,s=d.space["4X"].value,c=d.space["6X"].value,p=d.space["8X"].value,m=function(e,r){switch(e){case"primary":return`${t(1)} solid ${i.elements.primary[`on${r}`].value}`;case"secondary":return`${t(1)} solid ${"dark"===r?i.elements.lowcontrast.ondark.value:i.elements.lowcontrast.onlight.value}`;default:return"none"}},u=n.table.withConfig({displayName:"StyledTable",componentId:"VDS__sc-ag8xux-0"})`
  border-collapse: collapse;
  border-spacing: 0;
  text-align: left;
  width: 100%;
  font-size: ${t(14)};
  padding-top: ${t(18)};
  ${function({$hideBottomPadding:e}){return a`
    margin-bottom: ${e?void 0:t(d.space["8X"].value)};
  `}};
  ${function({$paddingHeader:e,$paddingCells:r}){return a`
    td {
      padding: ${r};
    }
    th {
      padding: ${e};
    }
  `}};
  ${function({$bottomLine:e,surface:r}){return a`
    thead {
      tr {
        border-bottom: ${m(e,r)};
      }
    }
  `}};
  ${function({$bottomLine:e,surface:r,$striped:t,$stripePattern:o}){return a`
    tbody {
      tr {
        border-bottom: ${m(e,r)};
        ${t&&`\n          &:nth-child(${o}) {\n            background-color: ${r&&i.background.secondary[r].value};\n          }\n        `}
      }
    }
  `}}
  ${function({surface:e,$stripePattern:r}){return"dark"===e&&a`
      td,
      th {
        color: ${i.elements.primary.ondark.value};
      }

      // Overriding tableHead bottomLine when surface is dark
      .thead-primary-line-override {
        tr {
          border-color: ${i.elements.primary.ondark.value} !important;
        }
      }
      .thead-secondary-line-override {
        tr {
          border-color: ${i.elements.lowcontrast.ondark.value} !important;
        }
      }
      .thead-none-line-override {
        tr {
          border: none !important;
        }
      }

      // Overriding boder-color color on any tableRow if bottomLine prop is passed
      tbody {
        .tr-primary-line-override {
          border-color: ${i.elements.primary.ondark.value} !important;
        }
        .tr-secondary-line-override {
          border-color: ${i.elements.lowcontrast.ondark.value} !important;
        }
        .tr-none-line-override {
          border: none !important;
        }
      }
      .tbody-striped-override {
        tr:nth-child(${r}) {
          background-color: ${i.background.secondary.dark.value} !important;
        }
      }
    `}};
  ${function({$striped:e}){return e&&a`
      thead {
        tr {
          border-bottom: none !important;
        }
      }
    `}}
  &:focus {
    outline: none;
  }
`;var b=o((function(o){var{striped:n,viewport:a,ariaLabel:i,"aria-label":d,children:m,surface:b="light",bottomLine:$="secondary",stripePattern:v="odd",padding:f="standard",hideBottomPadding:g=!1}=o,h=e(o,["striped","viewport","ariaLabel","aria-label","children","surface","bottomLine","stripePattern","padding","hideBottomPadding"]);const y=i||d;return r(u,Object.assign({},h,{surface:b,"aria-label":y||"Table",$paddingHeader:"compact"===f?"mobile"===a?t(l,n?l:c,l,n?l:0):t(s,n?s:p,s,n?s:0):"mobile"===a?t(c,n?l:c,c,n?l:0):t(p,n?s:p,p,n?s:0),$paddingCells:"compact"===f?"mobile"===a?t(l,n?l:c,l,n?l:0):t(s,n?s:p,s,n?s:0):"mobile"===a?t(c,n?l:c,c,n?l:0):t(p,n?s:p,p,n?s:0),$bottomLine:$,$stripePattern:v,$striped:n,padding:f,$hideBottomPadding:g,children:m}))}));export{b as default};
